import { motion } from "framer-motion";
import { IMAGES } from "@/lib/site";

const BADGES = [
  { dot: "bg-emerald-400", label: "Air, Bus & Rail Tickets" },
  { dot: "bg-amber-400", label: "Visa & Passport Desk" },
  { dot: "bg-sky-400", label: "Domestic & Global Tours" },
];

export const Hero = () => (
  <section
    id="top"
    className="relative min-h-[85vh] flex items-center justify-center py-20 px-4 sm:px-6 lg:px-8 text-white overflow-hidden bg-stone-950"
    data-testid="hero-section"
  >
    <img
      src={IMAGES.hero}
      alt="Family travellers on a journey planned by Parth Travels"
      className="absolute inset-0 w-full h-full object-cover"
      loading="eager"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-stone-950/90 via-stone-900/60 to-black/40" />
    <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#fff_1px,transparent_1px)] [background-size:24px_24px]" />

    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className="relative z-10 max-w-4xl mx-auto text-center space-y-8"
    >
      <h1 className="text-4xl sm:text-6xl lg:text-7xl font-bold tracking-tight font-serif-display leading-tight">
        Every Journey Under One Roof
      </h1>
      <p className="text-lg sm:text-xl text-stone-200 max-w-2xl mx-auto font-normal leading-relaxed">
        From air, bus, and railway tickets to complete visa and passport assistance, customized family holidays, and corporate trips · we handle every single detail so you can travel smoothly and on time.
      </p>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-2">
        <a
          href="#contact"
          data-testid="hero-enquire-btn"
          className="w-full sm:w-auto px-8 py-4 text-base font-semibold text-white bg-amber-700 hover:bg-amber-800 rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-0.5 text-center"
        >
          Enquire For Your Next Trip
        </a>
      </div>
      <div className="pt-6 border-t border-white/15 flex flex-wrap items-center justify-center gap-y-3 gap-x-8 text-xs sm:text-sm text-stone-300">
        {BADGES.map((b) => (
          <span key={b.label} className="inline-flex items-center gap-2">
            <span className={`w-2 h-2 rounded-full ${b.dot}`} /> {b.label}
          </span>
        ))}
      </div>
    </motion.div>
  </section>
);
